import React, { useState } from 'react';
import { Input, Button } from 'antd';
import { useSelector } from 'react-redux';
import alert from '@components/alert';

// import '@style/components/summary.scss';
import '../styles/components/summary.scss';

export const Summary = ({
  text,
  onUpdate,
  saveSummary,
  className,
  valueEdit,
  editState,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [textInput, setTextInput] = useState(text);
  const [isLoading, setIsLoading] = useState(false);

  const { buyerLabel, targetLabel } = useSelector(
    ({ common }) => common.projectCompanyInfo,
  );

  const projectId = useSelector((state) => state.common.currentId);

  const toggleEdit = () => {
    setIsEditing((v) => !v);
    editState && editState((v) => !v);
  };

  const updateSumaryAsync = (val) => async () => {
    if (val !== textInput) {
      setTextInput(val);
    }
    setIsLoading(true);
    await saveSummary(projectId, val);
    setIsLoading(false);
    toggleEdit();
    onUpdate();
  };

  const onSave = updateSumaryAsync(textInput);
  const onDelete = updateSumaryAsync('');

  const onCancel = () => {
    toggleEdit();
    setTextInput(text);
  };

  return (
    <div
      className={`summary-edit-wrapper ${className ? className : ''} ${
        isEditing ? 'is-editing' : ''
      }`}
    >
      <span className="summary-label">Summary</span>
      {valueEdit || isEditing ? null : (
        <span
          className="appkiticon icon-pencil-fill role-control"
          onClick={toggleEdit}
        />
      )}
      {isEditing ? (
        <>
          <Input.TextArea
            className="summary-textarea"
            value={textInput}
            onChange={(e) => setTextInput(e.target.value)}
          />
          <div className="action-btns">
            <span
              onClick={() => {
                alert.confirm({
                  content: 'Do you want to delete the Summary?',
                  okText: 'delete',
                  onOk: onDelete,
                });
              }}
            >
              delete summary
            </span>
            <div className="action-btns-right">
              <Button onClick={onCancel}>cancel</Button>
              <Button type="primary" onClick={onSave} loading={isLoading}>
                save
              </Button>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="summary-content">
            {text && text !== '' ? (
              text
            ) : (
              <span>
                Enter {`${targetLabel} & ${buyerLabel}`} summary here.
              </span>
            )}
          </div>
        </>
      )}
    </div>
  );
};
